import {ComparableOperator, Form, GroupOp, PosibleAnswer} from 'app/models/form';
import {QUESTION_TYPES} from 'app/modules/app-form/form-question.directive';
import {TableInputConfig} from 'app/shared/components/inputs/table-input/table-input.component';

const createMockForm = () => {
    const items = createMockPosibleAnswes();
    const tableConfig = createMockTableConfig();
    const answers = createMockAnswers();

    const formData: Form = {
        id: 0,
        code: 'string',
        name: 'string',
        formTypeId: 0,
        formSubTypeId: 0,
        active: true,
        questions: [
            QUESTION_TYPES.TEXT,
            QUESTION_TYPES.LIST,
            QUESTION_TYPES.SINGLE_OPTION,
            QUESTION_TYPES.MULTIPLE_ANSWERS,
            QUESTION_TYPES.ANSWERS_LIST,
            QUESTION_TYPES.FILES,
            QUESTION_TYPES.STATUS,
            QUESTION_TYPES.TABLE,
            QUESTION_TYPES.TEMPLATE,
        ].map((type, index) => {
            return {
                id: index,
                code: 'string',
                description: 'string',
                detail: 'string',
                questionTypeId: type,
                isRequired: true,
                commentAllowed: true,
                commentRequired: true,
                attachAllowed: true,
                attachRequired: true,
                templateFileId: 0,
                possibleAnswers: type == QUESTION_TYPES.STATUS ? items : items,
                dimensions: tableConfig.columns,
                answer: JSON.stringify({ value: answers[type] }),
                answerFiles: [],
                attachments: [{
                    id: 56,
                    fileId: 56,
                    file: {
                        id: 56,
                        name: 'Nombre de Archivo.extension',
                        mimeType: 'image/jpeg',
                    },
                    createdDate: new Date().toLocaleDateString(),
                }],
                comments: [{
                    id: 123,
                    comment: 'Comentario de algo',
                    createdDate: new Date().toLocaleDateString(),
                }],
                conditionalGroup: type != QUESTION_TYPES.TEXT ? null : {
                    operator: GroupOp.AND,
                    items: [
                        { questionId: 1, comparableOperator: ComparableOperator.NotEqual, comparableValue: "790" },
                    ],
                    childGroups: [],
                }
            };

        }),
        comments: [
            // {
            //   "id": 0,
            //   "comment": "string",
            //   "createdDate": new Date(),
            // }
        ]
    };
    return formData;
};

const createMockPosibleAnswes = () => {
    const mock: PosibleAnswer[] = [
        {
            code: 'customer',
            description: 'customer',
            id: 790,
            color: 'Red',
            requiresExplanation: false,
            commentsRequired: true
        },
        {
            code: 'enemy',
            description: 'enemy',
            id: 413,
            color: 'Yellow',
            requiresExplanation: false,
            commentsRequired: false
        },
        {
            code: 'though',
            description: 'though',
            id: 708,
            color: 'Blue',
            requiresExplanation: false,
            commentsRequired: true
        },
        {
            code: 'prove',
            description: 'prove',
            id: 247,
            color: 'Green',
            requiresExplanation: false,
            commentsRequired: true
        },
        {
            code: 'game',
            description: 'game',
            id: 589,
            color: 'Olive',
            requiresExplanation: false,
            commentsRequired: false
        },
        {
            code: 'arrow',
            description: 'arrow',
            id: 362,
            color: 'Lime',
            requiresExplanation: false,
            commentsRequired: false
        },
        {
            code: 'nation',
            description: 'nation',
            id: 912,
            color: 'White',
            requiresExplanation: false,
            commentsRequired: false
        },
        {
            code: 'urgent',
            description: 'urgent',
            id: 835,
            color: 'Blue',
            requiresExplanation: false,
            commentsRequired: false
        },
        {
            code: 'apology',
            description: 'apology',
            id: 530,
            color: 'Black',
            requiresExplanation: false,
            commentsRequired: false
        },
        {
            code: 'kiss',
            description: 'kiss',
            id: 31,
            color: 'Lime',
            requiresExplanation: false,
            commentsRequired: false
        },
    ];
    return mock;
};

const createMockTableConfig = () => {
    const tableConfig: TableInputConfig = {
        columns: [
            {
                code: 'G4J7S3Cr',
                id: 834,
                description: 'reward',
            },
            {
                code: 'Sij4b5UU',
                id: 735,
                description: 'pattern',
            },
            {
                code: 'nz05R9',
                id: 994,
                description: 'give',
            },
            {
                code: '5xfS47',
                id: 32,
                description: 'stir',
            },
        ]
    };
    return tableConfig;
};

const createMockAnswers = () => {
    const mockAnswers = {
        [QUESTION_TYPES.TEXT]: 'Olive',
        [QUESTION_TYPES.LIST]: null,
        [QUESTION_TYPES.SINGLE_OPTION]: 790,
        [QUESTION_TYPES.MULTIPLE_ANSWERS]: [790],
        [QUESTION_TYPES.ANSWERS_LIST]: ['Maroon', 'Aqua', 'Blue', 'Maroon', 'Red'],
        [QUESTION_TYPES.FILES]: [790],
        [QUESTION_TYPES.STATUS]: 790,
        [QUESTION_TYPES.TABLE]: [{
            'G4J7S3Cr': 'present',
            'Sij4b5UU': 'officer',
            'nz05R9': 'retire',
            '5xfS47': 'harden',
        }],
        [QUESTION_TYPES.TEMPLATE]: 790,
    };
    return mockAnswers;
};

export { createMockForm, createMockPosibleAnswes, createMockTableConfig, createMockAnswers };
